import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';

function audienceRu(a) {
  if (a === 'platform') return 'Платформа';
  if (a === 'teacher_students') return 'Ученики преподавателя';
  if (a === 'personal') return 'Личный';
  return a;
}

export default function KonspektyListPage() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [scope, setScope] = useState('all');

  const scopeOptions = useMemo(() => {
    if (!user) return [];
    if (user.is_student && !user.is_teacher) {
      return [
        { value: 'all', label: 'Все доступные' },
        { value: 'mine', label: 'Мои' },
        { value: 'from_teachers', label: 'Преподавателей' },
      ];
    }
    if (user.is_teacher || user.is_staff || user.is_admin) {
      return [
        { value: 'all', label: 'Все доступные' },
        { value: 'mine', label: 'Мои' },
        { value: 'from_students', label: 'Учеников' },
      ];
    }
    return [{ value: 'all', label: 'Все доступные' }, { value: 'mine', label: 'Мои' }];
  }, [user]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setErr('');
      try {
        const { data } = await api.get('/materials/konspekty/', { params: { scope } });
        const list = data.results ?? data;
        if (!cancelled) setItems(Array.isArray(list) ? list : []);
      } catch (e) {
        if (!cancelled) setErr(e.response?.data?.detail || 'Не удалось загрузить конспекты');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [scope]);

  const canCreate =
    user && (user.is_student || user.is_teacher || user.is_staff || user.is_admin);

  return (
    <div className="page konspekty-list-page">
      <div className="page-header konspekty-list-header">
        <h1>Конспекты</h1>
        {canCreate && (
          <Link to="/konspekty/new" className="btn btn-primary">
            Новый конспект
          </Link>
        )}
      </div>

      <div className="konspekty-scope-bar">
        {scopeOptions.map((o) => (
          <button
            key={o.value}
            type="button"
            className={scope === o.value ? 'konspekty-scope-btn active' : 'konspekty-scope-btn'}
            onClick={() => setScope(o.value)}
          >
            {o.label}
          </button>
        ))}
      </div>

      {loading && <p className="muted">Загрузка…</p>}
      {err && <p className="form-error">{err}</p>}

      {!loading && !items.length && !err && <p className="muted">Пока нет конспектов.</p>}

      <ul className="konspekty-cards">
        {items.map((k) => (
          <li key={k.id} className="konspekty-card">
            <Link to={`/konspekty/${encodeURIComponent(k.slug)}`} className="konspekty-card-title">
              {k.title}
            </Link>
            <div className="konspekty-card-meta">
              <span>{audienceRu(k.audience)}</span>
              {k.author_username && <span> · {k.author_username}</span>}
              <span> · просмотров: {k.views_count ?? 0}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
